import React, { useEffect, useState } from "react";
import GenericTable from "common/components/GenericTable/GenericTable";
import { ApiService } from "common/services/ApiService";

import {
    Container,
    Grid,
    IconButton,
    InputAdornment,
    TextField,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import FileDropzone from "common/components/FileDropzone/FileDropzone";

const DatasetsList = () => {
    const [datasets, setDatasets] = useState([]);
    const [filterDataset, setFilterDataset] = useState(null);

    useEffect(() => {
        async function getData() {
            const res = await ApiService.getStaticDataSources(null, null, {
                no_page: 1,
            });
            setDatasets(res);
            // const newArray = res.data.map((establishment) => {
            //     return { ...establishment, id: establishment.cue };
            // });
            // setDatasets(newArray);
        }

        getData();
    }, []);

    const filteredDatasets =
        typeof filterDataset === "string" && filterDataset.length > 0
            ? datasets.filter((dataset) => {
                  return dataset.name
                      .toLowerCase()
                      .includes(filterDataset.toLowerCase());
              })
            : datasets;

    const columns = [];
    // const rows = [
    //     {
    //         id: 1,
    //         location: "Snow",
    //         institutionName: "Jon",
    //     },
    //     { id: 2, location: "Lannister", institutionName: "Cersei" },
    //     { id: 3, location: "Lannister", institutionName: "Jaime" },
    //     { id: 4, location: "Stark", institutionName: "Arya" },
    //     { id: 5, location: "Targaryen", institutionName: "Daenerys" },
    //     { id: 6, location: "Melisandre", institutionName: "Asshai" },
    //     { id: 7, location: "Clifford", institutionName: "Ferrara" },
    //     { id: 8, location: "Frances", institutionName: "Rossini" },
    //     { id: 9, location: "Roxie", institutionName: "Harvey" },
    // ];

    return (
        <Container>
            <Grid container spacing={1}>
                <Grid item xs={12}>
                    <h1>Datasets</h1>
                </Grid>

                <Grid item xs={4}>
                    <TextField
                        id="outlined-basic"
                        label="Buscar por nombre"
                        variant="outlined"
                        fullWidth
                        onChange={(evt) => setFilterDataset(evt.target.value)}
                        InputProps={{
                            endAdornment: (
                                <InputAdornment position="end">
                                    <IconButton>
                                        <SearchIcon />
                                    </IconButton>
                                </InputAdornment>
                            ),
                        }}
                    />
                </Grid>
                <GenericTable rows={filteredDatasets} columns={columns} />
            </Grid>
        </Container>
    );
};

export default DatasetsList;
